/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S1_HeadingInputs */

const tr_kvkkbasvuru_s1_heading = /** @type {(inputs: Kvkkbasvuru_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Başvuru Hakkı`)
};

const en_kvkkbasvuru_s1_heading = /** @type {(inputs: Kvkkbasvuru_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Right to Apply`)
};

const de_kvkkbasvuru_s1_heading = /** @type {(inputs: Kvkkbasvuru_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Antragsrecht`)
};

const ru_kvkkbasvuru_s1_heading = /** @type {(inputs: Kvkkbasvuru_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Право на обращение`)
};

/**
* | output |
* | --- |
* | "1. Right to Apply" |
*
* @param {Kvkkbasvuru_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s1_heading = /** @type {((inputs?: Kvkkbasvuru_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s1_heading(inputs)
	if (locale === "de") return de_kvkkbasvuru_s1_heading(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s1_heading(inputs)
	return tr_kvkkbasvuru_s1_heading(inputs)
});